export default __webpack_public_path__ + "static/media/Harness of Ferine Anger.63e3288d.jpg";